import { Check, Loader2, Sparkles, X } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import "@/ai-dialog.css";

export function AiEmailDialog({ context, onApply, onClose }) {
  const [instruction, setInstruction] = useState("");
  const [variants, setVariants] = useState(null);
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    if (instruction.trim().length < 3) {
      toast.error("Décrivez l’e-mail souhaité, ou collez votre brouillon à corriger.");
      return;
    }
    setLoading(true);
    setVariants(null);
    try {
      const { data } = await api.post("/ai/email-draft", { instruction: instruction.trim(), context }, { timeout: 120000 });
      setVariants(data.variants);
    } catch (error) {
      toast.error(error.response?.data?.detail || "La génération IA a échoué. Réessayez.");
    } finally {
      setLoading(false);
    }
  };

  const apply = (variant) => {
    onApply(variant.subject, variant.body);
    toast.success(`Version « ${variant.label} » appliquée. Vous pouvez encore la modifier avant d’enregistrer.`);
    onClose();
  };

  return (
    <div className="ai-dialog-backdrop" onClick={onClose} data-testid="ai-dialog-backdrop">
      <div className="ai-dialog" onClick={(event) => event.stopPropagation()} data-testid="ai-email-dialog">
        <header className="ai-dialog-head">
          <div className="ai-dialog-title">
            <Sparkles size={18} />
            <div>
              <h3>Rédiger avec l’IA</h3>
              <p>Décrivez l’objectif de l’e-mail — ou collez un brouillon à corriger. Claude propose 3 variantes avec les variables déjà placées.</p>
            </div>
          </div>
          <button type="button" className="icon-action" onClick={onClose} aria-label="Fermer" data-testid="ai-close-button">
            <X size={18} />
          </button>
        </header>
        <textarea
          rows={4}
          value={instruction}
          onChange={(event) => setInstruction(event.target.value)}
          placeholder={"Ex. : relance polie une semaine après l’envoi du devis, rappeler que l’aide EDF couvre tout le montant\n— ou collez ici votre brouillon d’e-mail à corriger."}
          data-testid="ai-instruction-textarea"
        />
        <div className="button-row">
          <button className="primary-button" type="button" onClick={generate} disabled={loading} data-testid="ai-generate-button">
            {loading ? <Loader2 size={17} className="spinning" /> : <Sparkles size={17} />}
            {loading ? "Rédaction en cours…" : variants ? "Regénérer 3 variantes" : "Générer 3 variantes"}
          </button>
        </div>
        {loading && <p className="source-note" data-testid="ai-loading-note">Claude rédige vos 3 variantes, cela prend quelques secondes…</p>}
        {variants && (
          <div className="ai-variants" data-testid="ai-variants-list">
            {variants.map((variant, index) => (
              <article key={`${variant.label}-${index}`} className="ai-variant-card" data-testid={`ai-variant-card-${index}`}>
                <div className="ai-variant-head">
                  <span className="status-badge status-termine">{variant.label}</span>
                  <button className="secondary-button" type="button" onClick={() => apply(variant)} data-testid={`ai-use-variant-${index}`}>
                    <Check size={15} />Utiliser cette version
                  </button>
                </div>
                <p className="ai-variant-subject">Objet : {variant.subject}</p>
                <pre className="ai-variant-body">{variant.body}</pre>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
